/* eslint-disable react/no-array-index-key */
import React from "react";
import { useTranslation } from "react-i18next";

import { noDp } from "@/helpers/helpers";
import useAppStore from "@/store/appStateZustand";
import { useUIStateStore } from "@/store/uiStateStore";

import Map from "./_map";

function TabTerritories({ pending, result }) {
  const currencySymbol = useAppStore(s => s.tenantCurrencySymbol);
  const { t } = useTranslation("other");
  let territories = [];
  if (result?.body?.aggregations?.Territories) {
    territories = result?.body?.aggregations?.Territories.buckets.slice(0, 3);
  }

  const isTunecore = useUIStateStore(state => state.isTunecore);

  return (
    <div className="flex flex-col items-start h-full p-4">
      <h1 className={`text-md xl:text-xl font-medium ${isTunecore ? "text-white" : "text-black"} lg:mb-4`}>{t("other:territories-tab-header")}</h1>
      <h2 className={`text-xxs font-semibold ${isTunecore ? "text-white" : "text-ink-secondary"}`}>{t("other:top-territories")}</h2>
      {territories.map((s, i) => (
        <React.Fragment key={`territory${i}`}>
          <div className={`h-14 ${(i < (territories.length - 1) && i > 0) ? "border-b" : ""} flex w-full items-center justify-between font-sentric-alt`} key={`song${i}`}>
            <div className="flex flex-row text-xs font-semibold ">
              <span className="flex-none w-4 h-4 mr-2 text-xs text-white rounded-full bg-layer-raised">{(i + 1)}</span>
              <span className="text-left line-clamp-2 break-word">
                {s.key}
              </span>
            </div>
            <div className={`${isTunecore ? "text-white" : "text-black"}  font-medium text-xs`}>
              {currencySymbol}
              {noDp(s.WriterValues.value)}
            </div>
          </div>
          {i === 0
            && (
              <div className="relative w-full overflow-hidden rounded-lg">
                <Map pending={pending} buckets={result?.body?.aggregations?.Territories?.buckets || []} />
              </div>
            )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default TabTerritories;
